module.exports = __webpack_public_path__ + "img/form-banner-mobile.16715af2.png";